import { TREND_VALUES } from "./SummaryTable.consts"

export const getTrendType = (variationDifference: number) => {
	return variationDifference < 0
		? TREND_VALUES[2]
		: TREND_VALUES[Math.ceil(variationDifference)]
}

export const getSummaryTableConfig = (
	type: string,
	summaryPenetrationType: string
) => {
	return {
		title: `phronesis.transactional.application.commercial.benchmark.metric.select.penetration.chart.title.${type}`,
		headers: [
			`phronesis.transactional.application.commercial.benchmark.metric.select.penetration.summary.table.header.h1`,
			`phronesis.transactional.application.commercial.benchmark.metric.select.penetration.summary.table.header.h2`,
			`phronesis.transactional.application.commercial.benchmark.metric.select.penetration.summary.table.header.h3`,
		],
		firstColumn: [
			`phronesis.transactional.application.commercial.benchmark.metric.select.penetration.summary.table.${type}.${summaryPenetrationType}.v1`,
			`phronesis.transactional.application.commercial.benchmark.metric.select.penetration.summary.table.${type}.${summaryPenetrationType}.v2`,
			`phronesis.transactional.application.commercial.benchmark.metric.select.penetration.summary.table.${type}.${summaryPenetrationType}.v3`,
		],
	}
}

export const getAxisDomain = (variationDifference: number) => {
	return variationDifference > 0 ? [0, 1] : [-1, 0]
}
